import styled from '@emotion/styled';

import Button from '@skippay/core/components/Button';
import { media } from '@skippay/core/styles/media';
import { size } from '@skippay/core/styles/spacing';

export const SButton = styled(Button)`
	width: 100%;
	@media ${media.gt('MD')} {
		max-width: ${size(62)};
	}
`;
